import React from 'react'

const LilCard = ({ color, data, name, value, onClick, children }) => (
  <div
    onClick={onClick}
    style={{
      position: 'relative',
      minWidth: '100%',
    }}
  >
    <div className="overviewcard" style={{ borderLeft: `5px solid #900` }}>
      <p
        style={{
          position: 'absolute',
          top: '0',
          bottom: '0',
          left: '0',
          right: '0',
          paddingLeft: '20px',
        }}
      >
        {name}
      </p>
      {children}
      <div />

      <div
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: '0',
          bottom: '0',
          left: '0',
          right: '0',
          height: '100%',
          width: 'auto',
        }}
      />
    </div>
  </div>
)

export default LilCard
